@layer reset, default, hover, focus, print;

@layer reset {
  :host {
    display: block;

    .details__summary {
      display: block;
      border-color: transparent;
      background-color: transparent;
      cursor: pointer;
    }

    .details__panel {
      slot {
        display: initial;
      }

      ::slotted(*:first-child) {
        margin-block-start: 0;
      }

      ::slotted(*:last-child) {
        margin-block-end: 0;
      }

      ::slotted(ol),
      ::slotted(ul) {
        padding: 0;
      }
    }
  }
}

@layer default {
  :host .gcds-details {
    .details__summary {
      position: relative;
      padding: var(--gcds-details-summary-padding);
      color: var(--gcds-details-default-text);
      font: var(--gcds-details-font-desktop);
      text-align: left;
      text-decoration-style: solid;
      text-decoration-line: underline;
      text-decoration-color: currentColor;
      text-decoration-thickness: var(
        --gcds-details-default-decoration-thickness
      );
      text-underline-offset: 0.2em;
      transition:
        background-color 0.15s ease-in-out,
        color 0.15s ease-in-out;

      @media only screen and (width < 48em) {
        font: var(--gcds-details-font-mobile);
      }

      &:before {
        position: absolute;
        top: var(--gcds-details-summary-arrow-top);
        left: var(--gcds-details-summary-arrow-left);
        width: 0;
        height: 0;
        content: '';
        border-block-start: var(--gcds-details-summary-arrow-border-top-bottom)
          solid transparent;
        border-block-end: var(--gcds-details-summary-arrow-border-top-bottom)
          solid transparent;
        border-inline-start: var(--gcds-details-summary-arrow-border-left) solid
          currentColor;
        transition: transform 0.15s ease-in-out;
      }

      &[aria-expanded='false'] + .details__panel {
        clip-path: inset(100%);
        clip: rect(1px, 1px, 1px, 1px);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
      }

      &[aria-expanded='true']:before {
        transform: rotate(90deg);
      }
    }

    .details__panel {
      position: relative;
      margin: var(--gcds-details-panel-margin);
      padding: var(--gcds-details-panel-padding);

      summary {
        display: none;
      }

      &:before {
        position: absolute;
        display: block;
        top: 0;
        left: 0;
        width: var(--gcds-details-panel-border-width);
        height: 100%;
        content: '';
        background-color: var(--gcds-details-panel-border-color);
      }

      ::slotted(*) {
        font: var(--gcds-details-font-desktop);

        @media only screen and (width < 48em) {
          font: var(--gcds-details-font-mobile);
        }
      }

      ::slotted(*:not(:last-child)) {
        margin-block-start: 0 !important;
        margin-block-end: var(--gcds-details-panel-slotted-margin) !important;
      }

      ::slotted(ol),
      ::slotted(ul) {
        margin-inline-start: var(
          --gcds-details-panel-slotted-margin
        ) !important;
      }

      ::slotted(small) {
        font: var(--gcds-details-font-small-desktop);

        @media only screen and (width < 48em) {
          font: var(--gcds-details-font-small-mobile);
        }
      }
    }
  }
}

@layer hover {
  @media (hover: hover) {
    :host .gcds-details .details__summary:hover:not(:focus) {
      color: var(--gcds-details-hover-text);
      text-underline-offset: 0.2em;
      text-decoration-thickness: var(--gcds-details-hover-decoration-thickness);

      &:before {
        color: var(--gcds-details-hover-text);
      }
    }
  }
}

@layer focus {
  :host .gcds-details .details__summary:focus {
    border-radius: var(--gcds-details-focus-border-radius);
    background-color: var(--gcds-details-focus-background);
    color: var(--gcds-details-focus-text);
    box-shadow: var(--gcds-details-focus-box-shadow);
    outline-offset: var(--gcds-details-focus-outline-offset);
    outline: var(--gcds-details-focus-outline);
    text-decoration: none;
  }
}

@layer print {
  /* Display details component open by default for print */
  @media print {
    :host .gcds-details {
      .details__summary {
        font-weight: var(--gcds-details-print-summary-font-weight);
        text-decoration: none;
        color: var(--gcds-details-print-summary-text);

        &:before {
          transform: rotate(90deg);
        }
      }

      .details__panel {
        clip-path: none;
        clip: auto;
        height: auto;
        overflow: visible;
        position: static;
        white-space: normal;
        width: auto;
        display: block;
        /* Note: Logical properties are not yet supported in print */
        border-left: var(--gcds-details-panel-border-width) solid
          var(--gcds-details-panel-border-color);
      }
    }
  }
}
